<div
  *ngIf="options$ | async as options"
  [attr.data-automation-e2e-selector]="'muni-export-modal'"
>
  <div class="c-d-flex c-flex-column">
    <div *ngFor="let option of options" class="c-m-vertical-xs">
      <div class="c-d-flex c-flex-row c-justify-space-between">
        <span>
          <muni-shared-checkbox-option
            [name]="option.name"
            [checked]="option.isChecked"
            [disabled]="option.isDisabled"
            (changed)="exportPartOptionChecked(options, $event)"
          ></muni-shared-checkbox-option>
        </span>
        <span>
          <i class="fa fa-file-excel-o"></i>
        </span>
      </div>
      <div
        class="export-part-config c-p-left-sm c-p-top-xs"
        *ngIf="option.configOptions.length"
      >
        <div
          *ngFor="let configOption of option.configOptions"
          class="c-m-top-xs"
        >
          <muni-shared-checkbox-option
            [name]="configOption.name"
            [checked]="configOption.isChecked"
            [disabled]="
              !option.updatedWithConfigOpts
                ? !option.isChecked || configOption.isDisabled
                : configOption.isDisabled
            "
            (changed)="
              exportPartConfigOptionChecked(option.name, options, $event)
            "
          ></muni-shared-checkbox-option>
        </div>
      </div>
    </div>

    <div class="c-d-flex c-flex-row c-m-top-md export-actions">
      <div class="c-p-vertical-sm">
        <button
          class="c-btn c-btn-secondary cancel c-p-left-lg c-p-right-lg"
          (click)="cancel()"
        >
          Cancel
        </button>
      </div>
      <div class="c-p-vertical-sm">
        <button
          class="c-btn c-btn-primary export c-p-left-lg c-p-right-lg"
          (click)="export(options)"
          [disabled]="this.isExportDisabled$ | async"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</div>
